export default (word) =>
  word
    .split(" ")
    .map((w) => (w ? w[0].toUpperCase() + w.substring(1).toLowerCase() : ""))
    .join(" ");
